module.exports = __webpack_public_path__ + "static/media/bunk bed 3.73fe8486.jpg";